/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_TitleInputs */

const en_ui_thresholds_title = /** @type {(inputs: Ui_Thresholds_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thresholds`)
};

const de_ui_thresholds_title = /** @type {(inputs: Ui_Thresholds_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwellenwerte`)
};

/**
* | output |
* | --- |
* | "Thresholds" |
*
* @param {Ui_Thresholds_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_title = /** @type {((inputs?: Ui_Thresholds_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_title(inputs)
	return de_ui_thresholds_title(inputs)
});